<template>
    <modal :show.sync=show modalClasses="medium-sized-modal" headerClasses="pb-0" :hidefooter="true">
        <h3 slot="header" class="mb-0 font-weight-500">Commission Details</h3>
        <b-container>
            <template v-if="commission_details.case_recognize && commission_details.case_recognize.case">
                <b-row>
                    <b-col cols="6">
                        <p class="font-weight-600">Customer</p>
                    </b-col>
                    <b-col cols="6">
                        <p class="text-break">{{ commission_details.case_recognize.case.prod_customer_name }}</p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="6">
                        <p class="font-weight-600">Channel</p>
                    </b-col>
                    <b-col cols="6">
                        <p class="text-break">{{ commission_details.case_recognize.channel }}</p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="6">
                        <p class="font-weight-600">Platform</p>
                    </b-col>
                    <b-col cols="6">
                        <p class="text-break">{{ commission_details.case_recognize.platform }}</p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="6">
                        <p class="font-weight-600">Type</p>
                    </b-col>
                    <b-col cols="6">
                        <p class="text-break">{{ commission_details.case_recognize.lead_type_code }}</p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="6">
                        <p class="font-weight-600">Status</p>
                    </b-col>
                    <b-col cols="6">
                        <p class="text-break">{{commission_details.case_recognize.case.prod_main_status }}</p>
                    </b-col>
                </b-row>
                <b-row v-if="commission_details.comms_payout_summary && commission_details.comms_payout_summary.payout_distribution">
                    <b-col cols="6">
                        <p class="font-weight-600">Channel</p>
                    </b-col>
                    <b-col cols="6">
                        <p class="text-break">{{ commission_details.comms_payout_summary.payout_distribution.service_type_code }}</p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="6">
                        <p class="font-weight-600">Product</p>
                    </b-col>
                    <b-col cols="6">
                        <p class="text-break">{{ commission_details.case_recognize.case.prod_type }}</p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="6">
                        <p class="font-weight-600">Product Details</p>
                    </b-col>
                    <b-col cols="6">
                        <!-- <p class="text-break">{{ commission_details.case_recognize.case.prod_details }}</p> -->
                        <template>
                            <div v-if="commission_details.case_recognize.case.prod_type == 'property' || commission_details.case_recognize.case.prod_type == 'mortgage'">
                                <p class="text-break">{{ commission_details.case_recognize.case.prod_details.property_mortgage.prod_pm_project_name }}</p>
                                <p class="text-break">{{ commission_details.case_recognize.case.prod_details.property_mortgage.prod_pm_property_type }}</p>
                                <p class="text-break">{{ commission_details.case_recognize.case.prod_details.property_mortgage.prod_pm_lease_type }}</p>
                                <p class="text-break">{{ commission_details.case_recognize.case.prod_details.property_mortgage.prod_pm_unit_no }}</p>
                            </div>
                            <div v-else-if="commission_details.case_recognize.case.prod_type == 'personal_loan'">
                                <p class="text-break">{{ commission_details.case.prod_details.personal_loan.prod_pl_loan_agreement_rate }}</p>
                            </div>
                            <div v-else-if="commission_details.case_recognize.case.prod_type == 'insurance'">
                                <p class="text-break">{{ commission_details.case_recognize.case.prod_details.insurance.prod_ins_type }}</p>
                                <p class="text-break">{{ commission_details.case_recognize.case.prod_details.insurance.prod_ins_package }}</p>
                                <p class="text-break">{{ commission_details.case_recognize.case.prod_details.insurance.prod_ins_company }}</p>
                                <p class="text-break">{{ commission_details.case_recognize.case.prod_details.insurance.prod_ins_premium_pa }}</p>
                                <p class="text-break">{{ commission_details.case_recognize.case.prod_details.insurance.prod_ins_premium_pm }}</p>
                                <p class="text-break">{{ commission_details.case_recognize.case.prod_details.insurance.prod_ins_premium_cover }}</p>
                            </div>
                        </template>
                    </b-col>
                </b-row>
            </template>
            <!-- <b-row>
                <b-col cols="6">
                    <p class="font-weight-600">Capture</p>
                </b-col>
                <b-col cols="6">
                    <p class="text-break">{{ commission_details.capture }}</p>
                </b-col>
            </b-row> -->
            <template v-if="commission_details.comms_payout_summary">
                <b-row>
                    <b-col cols="6">
                        <p class="font-weight-600">Sales Value</p>
                    </b-col>
                    <b-col cols="6">
                        <p>RM {{ commission_details.comms_payout_summary.cps_develop_nett_price | moneyFormatter }}</p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="6">
                        <p class="font-weight-600">Revenue (%)</p>
                    </b-col>
                    <b-col cols="6">
                        <p>{{ commission_details.comms_payout_summary.cps_service_type_percentage }}</p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="6">
                        <p class="font-weight-600">Revenue Point</p>
                    </b-col>
                    <b-col cols="6">
                        <p>{{ commission_details.comms_payout_summary.cps_actual_total_revenue_point | moneyFormatter }}</p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="6">
                        <p class="font-weight-600">85% Direct Payout</p>
                    </b-col>
                    <b-col cols="6">
                        <p>{{ commission_details.comms_payout_summary.cps_actual_balance_revenue_point | moneyFormatter }}</p>
                    </b-col>
                </b-row>
            </template>
            <b-row>
                <b-col cols="6">
                    <p class="font-weight-600">Payout Level</p>
                </b-col>
                <b-col cols="6">
                    <p>{{ commission_details.payout_level_code }}</p>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="6">
                    <p class="font-weight-600">Payout Percentage (%)</p>
                </b-col>
                <b-col cols="6">
                    <p>{{ commission_details.payout_percentage }}</p>
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col cols="6">
                    <p class="font-weight-600">Commission</p>
                </b-col>
                <b-col cols="6" style="background: #5d79e340">
                    <span>RM</span>
                    <span class="float-right">{{ commission_details.actual_payout_revenue_point | moneyFormatter }}</span>
                </b-col>
            </b-row>
            <template v-if="commission_details.comms_payout_summary && commission_details.comms_payout_summary.pool_contribution_details">
                <b-row>
                    <b-col cols="6">
                        <p class="font-weight-600">Elite Pool</p>
                    </b-col>
                    <b-col cols="6">
                        <span>RM</span>
                        <span class="float-right">{{ commission_details.comms_payout_summary.pool_contribution_details[0].actual_pool_contribution_amount | moneyFormatter }}</span>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="6">
                        <p class="font-weight-600">Leadership Pool</p>
                    </b-col>
                    <b-col cols="6">
                        <span>RM</span>
                        <span class="float-right">{{ commission_details.comms_payout_summary.pool_contribution_details[1].actual_pool_contribution_amount | moneyFormatter }}</span>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="6">
                        <p class="font-weight-600">Champion Pool</p>
                    </b-col>
                    <b-col cols="6">
                        <span>RM</span>
                        <span class="float-right">{{ commission_details.comms_payout_summary.pool_contribution_details[2].actual_pool_contribution_amount | moneyFormatter }}</span>
                    </b-col>
                </b-row>
            </template>
            <b-row v-if="commission_details.comms_payout_summary">
                <b-col cols="6">
                    <p class="font-weight-600">Total 15% Pool</p>
                </b-col>
                <b-col cols="6" class="font-weight-600" style="background: #5d79e340">
                    <span>RM</span>
                    <span class="float-right">{{ commission_details.comms_payout_summary.cps_actual_pool_revenue_point | moneyFormatter }}</span>
                </b-col>
            </b-row>
        </b-container>
    </modal>
</template>
<script>
import Modal from "@/components/Modal"

export default {
    props: {
        show_commission_details: Boolean,
        commission_details: Object
    },
    components: {
        Modal,
    },
    computed: {
        show: {
            get() {
                return this.show_commission_details;
            },
            set(newVal) {
                this.$emit('update:show_commission_details', newVal);
            },
        },
    },
}
</script>